import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { campaigns } from '../data/plan';
import { span } from '../utils/stats';
const MONTH_MARKS = [{
  label: 'Aug 8',
  iso: '2026-08-08'
}, {
  label: 'Aug 17',
  iso: '2026-08-17'
}, {
  label: 'Aug 24',
  iso: '2026-08-24'
}, {
  label: 'Sep 1',
  iso: '2026-09-01'
}, {
  label: 'Sep 14',
  iso: '2026-09-14'
}, {
  label: 'Sep 22',
  iso: '2026-09-22'
}];
export function CampaignGantt() {
  const [active, setActive] = useState<string>(campaigns[0].id);
  const activeCampaign = campaigns.find(c => c.id === active) ?? campaigns[0];
  return <div data-id="element-29" data-mp="k149rkdt2jb5">
      <div className="relative mb-3 h-4" data-id="element-30" data-mp="k2nnp4bzoi9r">
        {MONTH_MARKS.map(m => {
        const {
          left
        } = span(m.iso, m.iso);
        return <span key={m.iso} className="absolute font-mono text-[10px] text-faint" style={{
          left: `${left}%`
        }} data-id="element-31" data-mp="f4m84tdrv131">
              {m.label}
            </span>;
      })}
      </div>

      <ul className="space-y-2" data-id="element-32" data-mp="29hbwywpa9k3k">
        {campaigns.map((c, i) => {
        const hero = span(c.heroStart, c.heroEnd);
        const second = c.secondStart && c.secondEnd ? span(c.secondStart, c.secondEnd) : null;
        const isActive = c.id === active;
        return <li key={c.id} data-id="element-33" data-mp="1b4lo5oln1589" data-mpi={i}>
              <button type="button" onClick={() => setActive(c.id)} aria-pressed={isActive} className={`group grid w-full grid-cols-[minmax(0,1fr)_minmax(0,2fr)] items-center gap-4 rounded-lg px-2 py-2 text-left transition-colors ${isActive ? 'bg-ink-800' : 'hover:bg-ink-800/60'}`} data-id="element-34" data-mp="1b5dk50j5d4z2">
                <span className={`truncate text-[13px] ${isActive ? 'text-chalk' : 'text-mute group-hover:text-chalk'}`} data-id="element-35" data-mp="1u02bgkdz7gvr">
                  {c.name}
                </span>
                <span className="relative h-6 rounded-md bg-ink-800/80" data-id="element-36" data-mp="2mozjzvsdxzbb">
                  <span className="absolute inset-0 grain rounded-md opacity-40" aria-hidden="true" data-id="element-37" data-mp="2ric5vy5ojs0d" />
                  {second && <span className="absolute top-1/2 h-[6px] -translate-y-1/2 rounded-full bg-campaign/25" style={{
                left: `${second.left}%`,
                width: `${second.width}%`
              }} data-id="element-38" data-mp="31chnwry4ipwo" />}
                  <motion.span initial={{
                scaleX: 0
              }} animate={{
                scaleX: 1
              }} transition={{
                duration: 0.6,
                delay: 0.05 * i,
                ease: [0.22, 1, 0.36, 1]
              }} style={{
                left: `${hero.left}%`,
                width: `${hero.width}%`,
                transformOrigin: 'left'
              }} className={`absolute top-1/2 h-[10px] -translate-y-1/2 rounded-full ${isActive ? 'bg-campaign' : 'bg-campaign/60'}`} data-id="element-39" data-mp="2mgs0cpdai4pu" />
                </span>
              </button>
            </li>;
      })}
      </ul>

      <div className="mt-4 rounded-xl border border-ink-700 bg-ink-800/60 px-4 py-3" data-id="element-40" data-mp="1upvmblfhtu0z">
        <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-faint" data-id="element-41" data-mp="a7jq1x52t24s">
          {activeCampaign.channels}
        </p>
        <p className="mt-1.5 text-[13px] leading-relaxed text-mute" data-id="element-42" data-mp="e6skl47xx41e">{activeCampaign.note}</p>
      </div>
    </div>;
}